import http from '@/common/api/http';
const baseUrl = "/newJava";

// 活动主页
export const actInfo = (params) => {
    return http.get(`/html5/activity/v1/nianhuo2022`, {params});
};

// 保存收货地址
export const saveAddress = (data) => {
    return http.post(`/html5/activity/V1/nianhuo2022SetAddr`, data);
};

// 报名接口
export const signUp = (data) => {
    return http.post(`/html5/activity/V1/nianhuo2022Signup`, data, {useLoading: true});
};

// 我的奖品
export const awardList = (params) => {
    return http.get(`/html5/activity/V1/nianhuo2022AwardInfo`, {params});
};

// 开奖明细
export const drawDetailList = (params) => {
    return http.get(`/html5/activity/V1/nianhuo2022DrawInfo`, {params});
};

// 抽奖接口
export const draw = (data) => {
    return http.post(`/html5/activity/v1/nianhuo2022LuckDraw`, data, {useLoading: true});
};

// 分享红包转链
export const convertSuperRedShareLink = (data) => {
    return http.post(`${baseUrl}/gylmJ/openapi/v1/convertSuperRedShareLink`, data, {useLoading: true});
};

// 领红包转链
export const convertSuperRedLink = (data) => {
    return http.post(`${baseUrl}/gylmJ/openapi/v1/convertSuperRedLink`, data, {useLoading: true});
};


// 快站配置信息
export const nianhuo2022Conf = (data) => {
    return http.post(`/html5/activity/v1/nianhuo2022Conf`, data);
};

